document.addEventListener('DOMContentLoaded', async (e) => {
  onLoadHandler();
});

/**
 * Handler for on-load event.
 */
function onLoadHandler() {
  let elements = document.querySelector('#contact-support-form').elements;

  // add 'on change' event handlers to all the form controls
  Array.from(elements).forEach(el => {
    el.addEventListener('change', (e) => {
      handleOnChangeEvents(e)
    });
  });

  //show / hide form elements in contact tech support form
  document.querySelector("#contact-support-box").style.display = 'none';
  document.querySelector("#confirm-review").addEventListener("click", function() {
    if (this.checked) {
      document.querySelector("#contact-support-box").style.display = 'block';
    }
    else {
      document.querySelector("#contact-support-box").style.display = 'none';
    }
  });

  document.querySelector('#contact-reason').addEventListener('change', function() {
    if (this.value === 'technical' || this.value === 'report-bug') {
      document.querySelector("#technical-questions").style.display = 'block';
    }
    else {
      document.querySelector("#technical-questions").style.display = 'none';
    }
  });
}

/**
 * Check if the submit section with submit button should be displayed.
 *
 * @param e
 */
function handleOnChangeEvents(e) {
  let validForm = false;
  let shouldShowTechnicalQuestions = false;

  // show 'other' input text fields when 'other' options checked
  let cbOtherBrowser = document.querySelector('#browser-other');
  let cbOtherDevice = document.querySelector('#device-other');
  let cbOtherOs = document.querySelector('#os-other');

  // Other browser
  if (cbOtherBrowser && cbOtherBrowser.checked) {
    document.querySelector('#browser-input').style.display = 'block';
    document.querySelector('#browser-other-input').style.display = 'block';
  } else {
    document.querySelector('#browser-input').style.display = 'none';
    document.querySelector('#browser-other-input').style.display = 'none';
  }

  // Other device
  if (cbOtherDevice && cbOtherDevice.checked) {
    document.querySelector('#device-input').style.display = 'block';
    document.querySelector('#device-other-input').style.display = 'block';
  } else {
    document.querySelector('#device-input').style.display = 'none';
    document.querySelector('#device-other-input').style.display = 'none';
  }

  // Other OS
  if (cbOtherOs && cbOtherOs.checked) {
    document.querySelector('#os-input').style.display = 'block';
    document.querySelector('#os-other-input').style.display = 'block';
  } else {
    document.querySelector('#os-input').style.display = 'none';
    document.querySelector('#os-other-input').style.display = 'none';
  }

  let name = document.querySelector('#name');
  let email = document.querySelector('#email');
  let reason = document.querySelector('#contact-reason');

  let device_desktop = document.querySelector('#device-desktop');
  let device_mobile = document.querySelector('#device-mobile');
  let device_tablet = document.querySelector('#device-tablet');
  let device_other = document.querySelector('#device-other');
  let device_other_input = document.querySelector('#device-other-input');

  let os_apple = document.querySelector('#os-apple');
  let os_android = document.querySelector('#os-android');
  let os_windows = document.querySelector('#os-windows');
  let os_linux = document.querySelector('#os-linux');
  let os_other = document.querySelector('#os-other');
  let os_other_input = document.querySelector('#os-other-input');

  let browser_chrome = document.querySelector('#browser-chrome');
  let browser_edge = document.querySelector('#browser-edge');
  let browser_firefox = document.querySelector('#browser-firefox');
  let browser_opera = document.querySelector('#browser-opera');
  let browser_safari = document.querySelector('#browser-safari');
  let browser_other = document.querySelector('#browser-other');
  let browser_other_input = document.querySelector('#browser-other-input');

  let device_selected, os_selected, browser_selected;

  shouldShowTechnicalQuestions =
    ['technical', 'report-bug'].includes(reason.value);
  // check device checkboxes
  device_selected =
    device_desktop.checked ||
    device_mobile.checked ||
    device_tablet.checked ||
    (device_other.checked && device_other_input.value.length > 0);

  // check os checkboxes
  os_selected =
    os_apple.checked ||
    os_android.checked ||
    os_windows.checked ||
    os_linux.checked ||
    (os_other.checked && os_other_input.value.length > 0);

  // check browsers selected
  browser_selected =
    browser_edge.checked ||
    browser_chrome.checked ||
    browser_firefox.checked ||
    browser_opera.checked ||
    browser_safari.checked ||
    (browser_other.checked && browser_other_input.value.length > 0);

  // check if we should display input field and submit button.
  let primaryFieldsHaveValue =
    name.value.length > 0 &&
    email.value.length > 0 &&
    reason.value.length > 0;

  if (shouldShowTechnicalQuestions) {
    validForm =
      primaryFieldsHaveValue &&
      device_selected &&
      os_selected &&
      browser_selected;
  } else {
    validForm = primaryFieldsHaveValue;
  }

  let submit_errors_note = document.querySelector("#submit-errors-notice");
  let text_area_submit = document.querySelector('#text-area-submit');
  let submit_support_button = document.querySelector("#submit-support-form-button");

  // Show Submit section if user has made a 'Reason' selection
  submit_support_button.disabled = true;
  submit_errors_note.style.display = 'none';
  text_area_submit.style.display = 'none';

  if (!['', 'Select a reason'].includes(reason.value)) {
    submit_errors_note.style.display = 'block';
    text_area_submit.style.display = 'block';
    if(validForm) {
      submit_support_button.disabled = false;
      submit_errors_note.style.display = 'none';
    }
  }
}
